import axios from "axios";
import UserInfo from "../../../../UserInfo/UserInfo";

export const CreateOrder = async (Package, Installment, totalPayment) => {
    let PayPrice;
    console.log("Installment in CreateOrderabc",Installment)
    console.log("totalPayment in CreateOrder",totalPayment)

    if (Installment === "Installments")
        PayPrice = (Package?.TotalFee / Package?.Installments).toFixed(2);
    else if (Installment === "Full") PayPrice = Package?.TotalFee;

    const { data } = await axios.post("/api/orders", {
        CoursePackageId: Package?.CoursePackageId,
        TotalPrice: totalPayment,
        Currency: "USD",
    });
    console.log("createorder", data);
    return data.id;
};

export const ApproveOrder = async (
    OrderId,
    Package,
    Installment,
    EnrollmentData,
    handleEnrollmentSuccess,
    StudentImage,
    UserInformation,
    SetLocalStorage,
    dispatch,
    LatestLicense,
    UserId,
    selectedPaymentMethod,
    cardDetails,
    totalPayment
) => {
    let PayPrice, InstallmentNumber;
    if (Installment === "Installments") {
        PayPrice = (Package?.TotalFee / Package?.Installments).toFixed(2);
        InstallmentNumber = 1;
    } else {
        PayPrice = Package?.TotalFee;
        InstallmentNumber = Package.Installments;
    }
    console.log("Studnetimageeee", StudentImage);
    console.log("totalPayment in ApproveOrder", totalPayment);
    console.log("PayPrice in ApproveOrder", PayPrice);
    console.log("InstallmentNumber in ApproveOrder", InstallmentNumber);

    const formData = new FormData();
    // Append the image data to the FormData object
    formData.append("StudentImage", StudentImage);
    formData.append("LatestLicense", LatestLicense);
    formData.append("CoursePackageId", Package.CoursePackageId);
    formData.append("TotalPrice", PayPrice);
    formData.append("Installments", InstallmentNumber);
    formData.append("InstallmentSchedule", Package.InstallmentSchedule);
    formData.append("UserId", UserId);
    formData.append("EnrollmentData", JSON.stringify(EnrollmentData));
    formData.append("PaymentMethod", selectedPaymentMethod);
    formData.append("totalPayment", totalPayment);


    // If the selected payment method is 'creditcard', append card details to formData
    if (selectedPaymentMethod === "creditcard" && cardDetails) {
        formData.append("CardBrand", cardDetails.brand);
        formData.append("CardExpMonth", cardDetails.exp_month);
        formData.append("CardExpYear", cardDetails.exp_year);
        formData.append("CardLast4", cardDetails.last4);
        formData.append("CardPostalCode", cardDetails.postal_code);
    }

    console.log("formData", formData);

    try {
       const res = await axios.post(
            `/api/orders/${OrderId}/capture`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        if(res?.status === 200) {
            handleEnrollmentSuccess()
            // DeleteLocalStorage("UserInfo")
            dispatch({
                type: "EnrollmentSuccess",
                payload: res?.data?.NewUserData,
                Auth: false,
            });
            SetLocalStorage("UserInfo", {
                ...UserInformation,
                ...res?.data?.NewUserData
            });
            
        }
        
    } catch (error) {
        // Check if error response exists and show the custom error message
        const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error || // in case you're using `error` field in response
        "Something went wrong. Please try again.";

        alert(errorMessage);
        console.error("Error:", errorMessage, error);
        console.error("Error:", error);
    }
};

export const CreateInstituteOrder = async (Package) => {
    let PayPrice = Package;

    try {
        // Make sure to follow the PayPal API's expected request structure
        const { data } = await axios.post("/api/instituteorders", {
            TotalPrice: PayPrice,
            Currency: "USD",
        });

        console.log("createorder", data);
        return data.id; // Assuming the returned data has the order ID
    } catch (error) {
        console.error("Error creating order:", error);
        throw new Error("Order creation failed");
    }
};


// export const CreateInstituteOrder = async (Package) => {
//     let PayPrice;
//     PayPrice = Package;

//     const { data } = await axios.post("/api/instituteorders", {
//         TotalPrice: PayPrice,
//         Currency: "USD",
//     });
//     console.log("createorder", data);
//     return data.id;
// };
